import { RecurringAllowance } from 'Utils/types/allowance'
import { CurrencyCode } from 'Utils/types/currencies'

export type RecurringAllowanceRow = {
  id: number
  allowanceType: string
  amount: number
  currencyCode: CurrencyCode
  cadence: string
  duration: string
  startDate: string
  active: boolean
  notes: string | null
  recurringAllowance: RecurringAllowance
  nextOccurrence: string
  user?: {
    id: number
    firstName: string
    lastName: string
    email: string
  }
}

export const convertRecurringAllowanceToTableRow = (
  recurringAllowance: RecurringAllowance
): RecurringAllowanceRow => {
  return {
    id: recurringAllowance.id,
    allowanceType: recurringAllowance.allowanceType,
    amount: recurringAllowance.amount,
    currencyCode: recurringAllowance.currencyCode,
    cadence: recurringAllowance.cadence,
    duration: recurringAllowance.duration,
    startDate: recurringAllowance.startDate,
    active: recurringAllowance.active,
    notes: recurringAllowance.notes,
    nextOccurrence: recurringAllowance.nextOccurrence,
    user: recurringAllowance.user,
    recurringAllowance
  }
}
